import React, { useState, useEffect } from "react";
import Sidebar from "../../../component/home/sidebar";
import { useDispatch, useSelector } from "react-redux";
import { changeTheme, getColorPalette } from "../../../redux/actions/palettes";
import { RESET_COLOR_PALETTES } from "../../../redux/constants";
import { default_color_palettes, encryptData } from "../../../utils";
import "react-drop-zone/dist/styles.css";
import Dropzone from "react-dropzone";
import ImageCrop from "./Component/ImageCrop";

function CustomizationIndex() {
  const dispatch = useDispatch();
  const { color_palettes } = useSelector((state) => state.palettes);
  const { logo, icon } = useSelector((state) => state.palettes);

  const [primaryColor, setPrimaryColor] = useState(color_palettes);
  const [uploadedLogo, setUploadedLogo] = useState();
  const [iconLogo, setIconLogo] = useState();
  const [defaultLogo, setDefaultLogo] = useState(logo);
  const [defaultIcon, setDefaultIcon] = useState(icon);
  const [remove_logo, setRemove_logo] = useState(false);
  const [remove_icon, setRemove_icon] = useState(false);

  // State to show image crop modal
  const [cropLogo, setCropLogo] = useState(false);
  const [cropIcon, setCropIcon] = useState(false);


  const handleSave = () => {
    let formdata = new FormData();
    const payload = {};

    if (process.env.REACT_APP_ENCRYPTION === "true") {
      if (primaryColor) {
        payload["color_palette"] = JSON.stringify(primaryColor);
      }
      if (remove_logo) {
        payload["remove_logo"] = remove_logo;
      }
      if (remove_icon) {
        payload["remove_icon"] = remove_icon;
      }
    } else {
      if (uploadedLogo) {
        formdata.append("logo", uploadedLogo[0]);
      }
      if (iconLogo) {
        formdata.append("icon", iconLogo[0]);
      }
      if (primaryColor) {
        formdata.append("color_palette", JSON.stringify(primaryColor));
      }
      if (remove_logo) {
        formdata.append("remove_logo", remove_logo);
      }
      if (remove_icon) {
        formdata.append("remove_icon", remove_icon);
      }
    }

    if (process.env.REACT_APP_ENCRYPTION === "true") {
      const keyData = encryptData(payload);
      formdata.append("key", keyData.key);
      if (uploadedLogo) {
        formdata.append("logo", uploadedLogo[0]);
      }
      if (iconLogo) {
        formdata.append("icon", iconLogo[0]);
      }
    }

    const request = {
      payload: formdata,
      onError: (err) => {
        console.log(err);
      },
    };
    dispatch(changeTheme(request));
  };

  const handleGenerateColor = () => {
    const request = {
      color: primaryColor[500].slice(1),
      onSuccess: (result) => {
        setPrimaryColor(result);
      },
      onError: (error) => {
        console.log("error", error);
      },
    };

    dispatch(getColorPalette(request));
  };

  const handleResetSetting = () => {

    const formdata = new FormData();

    const payload = {
      color_palette: JSON.stringify(default_color_palettes),
      remove_logo: true,
      remove_icon: true
    }

    if (process.env.REACT_APP_ENCRYPTION === "true") {
      const keyData = encryptData(payload);
      formdata.append("key", keyData.key);
    }else{
      formdata.append("color_palette", JSON.stringify(default_color_palettes));
      formdata.append("remove_logo", true);
      formdata.append("remove_icon", true);
    }

    const request = {
      payload: formdata,
      onError: (err) => {
        console.log(err);
      },
    };
    dispatch(changeTheme(request));

    setUploadedLogo();
    setIconLogo();
    setPrimaryColor(default_color_palettes);
  }


  return (
    <>
      {/* <div className="mt-4 sm:mx-6 lg:mx-8">
        <div
          className="flex flex-col md:flex-row"
          style={{ height: "calc(100vh - 70px)" }}
        > */}
          {/* <Sidebar /> */}
          {/* md:w-2/3 */}
          <div className="flex-auto bg-white max-h-full w-full space-y-8 relative mt-3">
            <div className="flex items-center justify-between space-x-5">
              <div className="w-full space-y-3">
                <h4 className="text-base font-semibold text-[#1E293B] leading-5 tracking-tight">
                  Full Logo (Sidebar Menu)
                </h4>
                <div>
                  <Dropzone
                    accept={{
                      "image/*": [], // Accepts all image formats
                    }}
                    onDrop={(acceptedFiles) => {
                      setUploadedLogo(acceptedFiles);
                      setCropLogo(true);
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section className="border-2 border-dashed border-[#94A3B8] h-[140px] flex justify-center items-center bg-white rounded-lg">
                        <div {...getRootProps()}>
                          <input {...getInputProps()} />
                          <div className="space-y-2">
                            {uploadedLogo ? (
                              <div className="w-full h-full text-center relative">
                                <img
                                  src={URL.createObjectURL(uploadedLogo[0])}
                                  alt="uploadedLogo"
                                  className="w-full h-[120px] object-cover"
                                />
                                <div className="absolute top-0 -right-10 space-x-1">
                                  <span
                                    class="fa-solid fa-square-x text-rose-500 cursor-pointer"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      setUploadedLogo();
                                      setRemove_logo(true);
                                    }}
                                  ></span>
                                  {/* <span
                                    className="fa-solid fa-crop text-[#9297a2] cursor-pointer"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                    }}
                                  ></span> */}
                                </div>
                              </div>
                            ) : defaultLogo ? (
                              <div className="w-full h-full text-center relative">
                                <img
                                  src={defaultLogo}
                                  alt="uploadedLogo"
                                  className="w-full h-[120px] object-cover"
                                />
                                <span
                                  class="fa-solid fa-square-x text-rose-500 cursor-pointer absolute top-0 -right-5"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    setDefaultLogo();
                                    setRemove_logo(true);
                                  }}
                                ></span>
                              </div>
                            ) : (
                              <>
                                <span class="fa-light fa-arrow-up-from-bracket text-2xl font-normal block text-center"></span>
                                <h4 className="text-sm text-[#94A3B8] font-medium">
                                  Drop your uploadedLogo here or
                                </h4>
                                <div className="flex justify-center">
                                  <button className="btn !border !border-[--bg-color-500] text-[--bg-color-500] flex justify-center">
                                    Browse Files
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </div>
              </div>
              <div className="w-full space-y-3">
                <h4 className="text-base font-semibold text-[#1E293B] leading-5 tracking-tight">
                  Icon Logo (Sidebar Menu)
                </h4>
                <div>
                  <Dropzone
                    accept={{
                      "image/*": [], // Accepts all image formats
                    }}
                    onDrop={(acceptedFiles) => {
                      setIconLogo(acceptedFiles)
                      setCropIcon(true);
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section className="border-2 border-dashed border-[#94A3B8] h-[140px] flex justify-center items-center bg-white rounded-lg">
                        <div {...getRootProps()}>
                          <input {...getInputProps()} />
                          <div className="space-y-2">
                            {iconLogo ? (
                              <div className="w-full h-full text-center relative">
                                <img
                                  src={URL.createObjectURL(iconLogo[0])}
                                  alt="uploadedLogo"
                                  className="w-full h-[120px] object-cover"
                                />
                                <span
                                  class="fa-solid fa-square-x text-rose-500 cursor-pointer absolute top-0 -right-5"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    setIconLogo();
                                    setRemove_icon(true);
                                  }}
                                ></span>
                              </div>
                            ) : defaultIcon ? (
                              <div className="w-full h-full text-center relative">
                                <img
                                  src={defaultIcon}
                                  alt="uploadedLogo"
                                  className="w-full h-[120px] object-cover"
                                />
                                <span
                                  class="fa-solid fa-square-x text-rose-500 cursor-pointer absolute top-0 -right-5"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    setDefaultIcon();
                                    setRemove_icon(true);
                                  }}
                                ></span>
                              </div>
                            ) : (
                              <>
                                <span class="fa-light fa-arrow-up-from-bracket text-2xl font-normal block text-center"></span>
                                <h4 className="text-sm text-[#94A3B8] font-medium">
                                  Drop your uploadedLogo here or
                                </h4>
                                <div className="flex justify-center">
                                  <button className="btn !border !border-[--bg-color-500] text-[--bg-color-500] flex justify-center">
                                    Browse Files
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </div>
              </div>
            </div>

            <div className="mt-1 space-y-4">
              <h4 className="text-base font-semibold text-[#1E293B]">
                Colour Scheme
              </h4>
              <div className="space-x-4 flex items-center">
                <label
                  htmlFor="primary-color"
                  style={{ backgroundColor: primaryColor[500] }}
                  className="w-[60px] h-[60px] cursor-pointer rounded-xl text-white text-sm font-normal flex justify-center items-end relative"
                >
                  500
                  <input
                    id="primary-color"
                    className="absolute bottom-0 invisible"
                    type="color"
                    value={primaryColor[500]}
                    onChange={(e) =>
                      setPrimaryColor({ ...primaryColor, 500: e.target.value })
                    }
                  />
                </label>
                <h2 className="leading-full text-[#94A3B8]">
                  <span className="font-semibold text-[#1E293B]">
                    Primary Colour {primaryColor[500]}
                  </span>
                  <br></br>
                  Used for buttons, highlighted text etc.
                </h2>
              </div>
              <button
                className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 mt-4"
                onClick={() => handleGenerateColor()}
              >
                Generate Color Scheme
              </button>
            </div>

            <div className="grid grid-cols-2 gap-4 relative">
              <div className="space-y-4 ">
                <div className="flex items-center space-x-4">
                  <label
                    htmlFor="primary-color-50"
                    style={{ backgroundColor: primaryColor[50] }}
                    className="w-[60px] h-[60px] rounded-[12px] flex justify-center items-end text-[#1E293B] text-sm relative cursor-pointer"
                  >
                    50
                    <input
                      id="primary-color-50"
                      className="absolute bottom-0 invisible"
                      type="color"
                      value={primaryColor[50]}
                      onChange={(e) =>
                        setPrimaryColor({ ...primaryColor, 50: e.target.value })
                      }
                    />
                  </label>
                  <div className="">
                    <h3 className="text-sm text-[#1E293B] font-semibold tracking-wide">
                      {primaryColor[50]}
                    </h3>
                    <h6 className="text-sm text-[#94A3B8]">
                      Used for light backgrounds, table rows etc.
                    </h6>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <label
                    htmlFor="primary-color-100"
                    style={{ backgroundColor: primaryColor[100] }}
                    className="w-[60px] h-[60px] rounded-[12px] flex justify-center items-end text-[#1E293B] text-sm cursor-pointer relative"
                  >
                    100
                    <input
                      id="primary-color-100"
                      className="absolute bottom-0 invisible"
                      type="color"
                      value={primaryColor[100]}
                      onChange={(e) =>
                        setPrimaryColor({
                          ...primaryColor,
                          100: e.target.value,
                        })
                      }
                    />
                  </label>
                  <div className="">
                    <h3 className="text-sm text-[#1E293B] font-semibold tracking-wide">
                      {primaryColor[100]}
                    </h3>
                    <h6 className="text-sm text-[#94A3B8]">
                      Used for table headers, card backgrounds etc.
                    </h6>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <label
                    htmlFor="primary-color-200"
                    style={{ backgroundColor: primaryColor[200] }}
                    className="w-[60px] h-[60px] rounded-[12px] flex justify-center items-end text-[#1E293B] text-sm cursor-pointer relative"
                  >
                    200
                    <input
                      id="primary-color-200"
                      className="absolute bottom-0 invisible"
                      type="color"
                      value={primaryColor[200]}
                      onChange={(e) =>
                        setPrimaryColor({
                          ...primaryColor,
                          200: e.target.value,
                        })
                      }
                    />
                  </label>
                  <div className="">
                    <h3 className="text-sm text-[#1E293B] font-semibold tracking-wide">
                      {primaryColor[200]}
                    </h3>
                    <h6 className="text-sm text-[#94A3B8]">
                      Used for light backgrounds, table rows etc.
                    </h6>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <label
                    htmlFor="primary-color-300"
                    style={{ backgroundColor: primaryColor[300] }}
                    className="w-[60px] h-[60px] rounded-[12px] flex justify-center items-end text-[#1E293B] text-sm cursor-pointer relative"
                  >
                    300
                    <input
                      id="primary-color-300"
                      className="absolute bottom-0 invisible"
                      type="color"
                      value={primaryColor[300]}
                      onChange={(e) =>
                        setPrimaryColor({
                          ...primaryColor,
                          300: e.target.value,
                        })
                      }
                    />
                  </label>
                  <div className="">
                    <h3 className="text-sm text-[#1E293B] font-semibold tracking-wide">
                      {primaryColor[300]}
                    </h3>
                    <h6 className="text-sm text-[#94A3B8]">
                      Used for light backgrounds, table rows etc.
                    </h6>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <label
                    htmlFor="primary-color-400"
                    style={{ backgroundColor: primaryColor[400] }}
                    className="w-[60px] h-[60px] rounded-[12px] flex justify-center items-end text-[#1E293B] text-sm cursor-pointer relative"
                  >
                    400
                    <input
                      id="primary-color-400"
                      className="absolute bottom-0 invisible"
                      type="color"
                      value={primaryColor[400]}
                      onChange={(e) =>
                        setPrimaryColor({
                          ...primaryColor,
                          400: e.target.value,
                        })
                      }
                    />
                  </label>
                  <div className="">
                    <h3 className="text-sm text-[#1E293B] font-semibold tracking-wide">
                      {primaryColor[400]}
                    </h3>
                    <h6 className="text-sm text-[#94A3B8]">
                      Used for light backgrounds, table rows etc.
                    </h6>
                  </div>
                </div>
              </div>
              <div className="space-y-4 ">
                <div className="flex items-center space-x-4">
                  <label
                    htmlFor="primary-color-600"
                    style={{ backgroundColor: primaryColor[600] }}
                    className="w-[60px] h-[60px] rounded-[12px] flex justify-center items-end text-white text-sm relative cursor-pointer"
                  >
                    600
                    <input
                      id="primary-color-600"
                      className="absolute bottom-0 invisible"
                      type="color"
                      value={primaryColor[600]}
                      onChange={(e) =>
                        setPrimaryColor({
                          ...primaryColor,
                          600: e.target.value,
                        })
                      }
                    />
                  </label>
                  <div className="">
                    <h3 className="text-sm text-[#1E293B] font-semibold tracking-wide">
                      {primaryColor[600]}
                    </h3>
                    <h6 className="text-sm text-[#94A3B8]">
                      Used for light backgrounds, table rows etc.
                    </h6>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <label
                    htmlFor="primary-color-700"
                    style={{ backgroundColor: primaryColor[700] }}
                    className="w-[60px] h-[60px] rounded-[12px] flex justify-center items-end text-white text-sm relative
                  cursor-pointer"
                  >
                    700
                    <input
                      id="primary-color-700"
                      className="absolute bottom-0 invisible"
                      type="color"
                      value={primaryColor[700]}
                      onChange={(e) =>
                        setPrimaryColor({
                          ...primaryColor,
                          700: e.target.value,
                        })
                      }
                    />
                  </label>
                  <div className="">
                    <h3 className="text-sm text-[#1E293B] font-semibold tracking-wide">
                      {primaryColor[700]}
                    </h3>
                    <h6 className="text-sm text-[#94A3B8]">
                      Used for light backgrounds, table rows etc.
                    </h6>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <label
                    htmlFor="primary-color-800"
                    style={{ backgroundColor: primaryColor[800] }}
                    className="w-[60px] h-[60px] rounded-[12px] flex justify-center items-end text-white text-sm cursor-pointer relative"
                  >
                    800
                    <input
                      id="primary-color-800"
                      className="absolute bottom-0 invisible"
                      type="color"
                      value={primaryColor[800]}
                      onChange={(e) =>
                        setPrimaryColor({
                          ...primaryColor,
                          800: e.target.value,
                        })
                      }
                    />
                  </label>
                  <div className="">
                    <h3 className="text-sm text-[#1E293B] font-semibold tracking-wide">
                      {primaryColor[800]}
                    </h3>
                    <h6 className="text-sm text-[#94A3B8]">
                      Used for light backgrounds, table rows etc.
                    </h6>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <label
                    style={{ backgroundColor: primaryColor[900] }}
                    className="w-[60px] h-[60px] rounded-[12px] flex justify-center items-end text-white text-sm relative cursor-pointer"
                  >
                    900
                    <input
                      id="primary-color-900"
                      className="absolute bottom-0 invisible"
                      type="color"
                      value={primaryColor[900]}
                      onChange={(e) =>
                        setPrimaryColor({
                          ...primaryColor,
                          900: e.target.value,
                        })
                      }
                    />
                  </label>
                  <div className="">
                    <h3 className="text-sm text-[#1E293B] font-semibold tracking-wide">
                      {primaryColor[900]}
                    </h3>
                    <h6 className="text-sm text-[#94A3B8]">
                      Used for light backgrounds, table rows etc.
                    </h6>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <label
                    htmlFor="primary-color-950"
                    style={{ backgroundColor: primaryColor[950] }}
                    className="w-[60px] h-[60px] rounded-[12px] flex justify-center items-end text-white text-sm relative cursor-pointer"
                  >
                    950
                    <input
                      id="primary-color-950"
                      className="absolute bottom-0 invisible"
                      type="color"
                      value={primaryColor[950]}
                      onChange={(e) =>
                        setPrimaryColor({
                          ...primaryColor,
                          950: e.target.value,
                        })
                      }
                    />
                  </label>
                  <div className="">
                    <h3 className="text-sm text-[#1E293B] font-semibold tracking-wide">
                      {primaryColor[950]}
                    </h3>
                    <h6 className="text-sm text-[#94A3B8]">
                      Used as the primary text colour, for the side bar menu
                      etc.
                    </h6>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-4">

              <button
                className="btn bg-[--bg-color-500] text-white hover:bg-[--bg-color-600] cursor-pointer absolute right-5"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSave();
                }}
              >
                Update Design Scheme
              </button>
              <button
                className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 mb-4"
                onClick={(e) => {
                  e.stopPropagation();
                  handleResetSetting();
                }}
              >
                Reset Settings
              </button>
            </div>
          </div>
        {/* </div> */}
        <ImageCrop
          modalOpen={cropLogo}
          setModalOpen={setCropLogo}
          uploadedImage={uploadedLogo}
          setUploadedImage={setUploadedLogo}
        />
        <ImageCrop
          modalOpen={cropIcon}
          setModalOpen={setCropIcon}
          uploadedImage={iconLogo}
          setUploadedImage={setIconLogo}
        />
      {/* // </div> */}
    </>
  );
}

export default CustomizationIndex;
